// ABOUTME: Hook to set up admin justification interceptor with context
// ABOUTME: Connects the axios interceptor to the justification modal context

import { useEffect, useRef } from 'react';
import { useAdminJustification } from '../contexts/AdminJustificationContext';
import { setupAdminJustificationInterceptor, setJustificationCallback } from '../utils/adminJustificationInterceptor';

export const useAdminJustificationSetup = () => {
  const { requestJustification } = useAdminJustification();
  const requestJustificationRef = useRef(requestJustification);

  // Update ref when function changes
  useEffect(() => {
    requestJustificationRef.current = requestJustification;
  }, [requestJustification]);

  useEffect(() => {
    // Set the callback for the interceptor to use
    setJustificationCallback((resourceType: string, resourceId: string | number, resourceName?: string) => 
      requestJustificationRef.current(resourceType, resourceId, resourceName)
    );
    
    // Set up the interceptor
    setupAdminJustificationInterceptor();
    
    // Cleanup on unmount
    return () => {
      setJustificationCallback(null);
    };
  }, []); // Empty dependency array - only run once
};